// extracted by mini-css-extract-plugin
export default {"overdueLabel":"styles_overdueLabel__UC0er","icon":"styles_icon__-zRWJ","text":"styles_text__wPA8T"};